<template>
    <div id="headers">
        <i class="arr" v-if="title=='分享有奖' || title=='优惠券'" @click="closeBag"></i>
        <i class="arr" v-else @click="goBack()"></i>
        <p class="title">{{title}}</p>
        <i class="search" v-if="title=='选择社区'" @click="search"></i>
        <i class="close" v-if="title=='选择您所在小区/社区'&&type=='errortype'" @click="close">关闭</i>
    </div>
</template>
<script>
import {mapMutations} from 'vuex'
export default {
    props:['title','id','type'],
    data() {
        return {

        }
    },
    methods:{
        ...mapMutations(['goBack']),     
        search() {
            this.$router.push({
                path:'/search'
            })
        },
        close() {
          this.isScreen('app://back');
        },
        // 关闭分享有奖
        closeBag() {
          if(this.isAndroid() || this.isIos()) {
            location.href = 'app://back'
          }else{
            window.history.back()
          }
        }
    }
}
</script>
<style lang="less">
    #headers{
        .close{
            position: absolute;
            left:40px;
            font-size: 17px;
            font-style: normal;
        }
    }
</style>




// WEBPACK FOOTER //
// src/component/top/top.vue